"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("../../helpers/path"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _CryptoNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/CryptoNavItemsContainer"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _FiatNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/FiatNavItemsContainer"));
require("./WalletRow.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var walletRowClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-row');
var WalletRow = function WalletRow(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var iconFileName = props.iconFileName,
    ProductSymbol = props.ProductSymbol,
    ProductFullName = props.ProductFullName,
    isCrypto = props.isCrypto,
    ProductId = props.ProductId,
    width = props.width,
    detailsLink = props.detailsLink,
    isWithdrawAllowed = props.isWithdrawAllowed,
    isDepositAllowed = props.isDepositAllowed;
  var replaceActivityLink = width < 768 ? true : false;
  var iconSize = width > 1024 ? 44 : 28;
  var renderActivityLink = function renderActivityLink() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: walletRowClasses('activity-link')
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: walletRowClasses('activity-link'),
      to: (0, _path["default"])(detailsLink),
      onClick: props.selectPositionAndSave
    }, t('Details'), " ", /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "arrowNext",
      customClass: walletRowClasses('next-icon')
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses('icon-label')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses('product-icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: iconFileName,
    size: iconSize
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses('symbol-label')
  }, "".concat(ProductSymbol, " ").concat(ProductFullName), replaceActivityLink && renderActivityLink())), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses('activity-link-columns')
  }, !replaceActivityLink && renderActivityLink(), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowClasses('icon-nav-buttons')
  }, isCrypto ? /*#__PURE__*/_react["default"].createElement(_CryptoNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      isWithdrawAllowed: isWithdrawAllowed,
      isDepositAllowed: isDepositAllowed
    },
    showIconButtonLabel: false
  }) : /*#__PURE__*/_react["default"].createElement(_FiatNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      isWithdrawAllowed: isWithdrawAllowed,
      isDepositAllowed: isDepositAllowed
    },
    showIconButtonLabel: false
  }))));
};
var _default = exports["default"] = WalletRow;